import { Document } from '../DocumentsModal/DocumentsModal'
import { FileData } from './WorkflowPreviewModal'

interface Props {
  document: Document
  fileData: FileData
}
export function NoPreviewAvailable({ document, fileData }: Props) {
  return (
    <div className="noPreviewAvailable">
      <span>No preview available</span>
      <div className="document-drop-box-actions">
        <span>{fileData.filename}</span>
        {!!document.documentId && (
          <a href={fileData.fileURL} download={fileData.filename}>
            <i className="icon-download" />
          </a>
        )}
      </div>
    </div>
  )
}
